import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_CONTENT } from '../content';

const ExperienceSection = () => {
  const exp = SITE_CONTENT.pages?.aboutUsPage?.experienceSection || {};
  const subtitle = exp.subtitle || "The Nawabi Difference";
  const title = exp.title || "The Full Royal Experience";
  const buttonText = exp.buttonText || "Book Us Now";
  const experiences = exp.experiences || [];

  return (
    <section className="bg-[#f0ebe0] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        {/* Section header */}
        <p className="text-[#1a2e1a] text-xs tracking-[0.3em] uppercase font-medium mb-4">
          {subtitle}
        </p>
        <h2 className="text-[#1a2e1a] text-3xl sm:text-4xl font-semibold mb-12">
          {title}
        </h2>

        {/* Cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {experiences.map((item) => (
            <div
              key={item.title}
              className="group bg-[#e8e3d8] rounded-sm overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              {/* Image */}
              <div className="overflow-hidden h-[220px] lg:h-[240px]">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                {/* Small label */}
                <p className="text-[#1a2e1a] text-[10px] tracking-[0.25em] uppercase font-semibold mb-2">
                  {item.label}
                </p>

                {/* Title */}
                <h3 className="text-[#1a2e1a] text-xl font-semibold mb-3">
                  {item.title}
                </h3>

                {/* Description */}
                <p className="text-[#6b6b58] text-sm leading-relaxed mb-5">
                  {item.description}
                </p>

                {/* CTA */}
                <Link
                  to={item.to}
                  className="inline-block px-5 py-2.5 bg-[#1a2e1a] text-white text-xs tracking-[0.15em] uppercase font-medium rounded-full hover:bg-[#2d4a2d] transition-all duration-300 hover:scale-105"
                >
                  {buttonText}
                </Link>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ExperienceSection;
